// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".t-move[data-v-f2f24336]{transition:all .2s linear;transform:.3s translateX(-1em)}.t-enter-active[data-v-f2f24336],.t-leave-active[data-v-f2f24336]{transition:opacity .2s linear,transform .2s}.t-enter-active[data-v-f2f24336]{transition-delay:.2s}.t-enter[data-v-f2f24336],.t-leave-to[data-v-f2f24336]{opacity:0}.t-enter[data-v-f2f24336]{transform:translateX(-1rem)}.t-leave-to[data-v-f2f24336]{transform:translateX(1em)}", ""]);
// Exports
module.exports = exports;
